import {
  DialogDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  type MenuItemProps,
  MenuProvider,
  MenuSeparator,
  type MenuStoreState,
} from "@ariakit/react";
import type { ReactElement, ReactNode } from "react";
import { Link } from "wouter";
import { MoreIcon } from "../PageHeaderButton/Icon.tsx";
import * as css from "./style.css.ts";

export function MoreMenu(props: {
  label?: string;
  children?: ReactNode;
  iconColor?: string;
  className?: string;
  placement?: MenuStoreState["placement"];
  icon?: ReactElement;
}) {
  const { placement } = props;

  return (
    <MenuProvider placement={placement ?? "top-end"}>
      <MenuButton className={props.className ?? css.menuButton}>
        <MoreIcon />
      </MenuButton>

      <Menu className={css.menu}>{props.children}</Menu>
    </MenuProvider>
  );
}

export function MoreMenuItem(props: Omit<MenuItemProps, "className">) {
  return <MenuItem {...props} className={css.menuItem} />;
}

export function MenuLink(
  props: Omit<MenuItemProps, "className" | "render"> & { href: string },
) {
  return (
    <MenuItem
      {...props}
      className={css.menuItem}
      render={<Link href={props.href} />}
    />
  );
}

export function MoreMenuDialogDisclosure(
  props: Omit<MenuItemProps, "className" | "render">,
) {
  return (
    <MenuItem
      {...props}
      className={css.menuItem}
      render={<DialogDisclosure />}
    />
  );
}

export function MoreMenuSeparator() {
  return <MenuSeparator className={css.menuSeparator} />;
}
